import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { formatOrderTiming } from '../../../util/orderTiming';
import useMarketplaceTiming from '../../../hooks/useMarketplaceTiming';

function FilterLabel({ time, type }) {
  const marketplaceTiming = useMarketplaceTiming();
  const context = useSelector((state) => ({
    type: state.order?.type?.value,
    timezone: state.restaurant?.selectedRestaurantData?.timezone,
  }));
  return (
    <span>
      {formatOrderTiming(
        time,
        type?.value || context.type,
        marketplaceTiming ? undefined : context.timezone
      )}
    </span>
  );
}

FilterLabel.propTypes = {
  time: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  type: PropTypes.shape({ value: PropTypes.string }),
};
FilterLabel.defaultProps = { time: null, type: null };
export default memo(FilterLabel);
